import React from 'react';
import { ResourceTypes, ResourceOperations } from '../../../authentication/resources';
import { Restricted } from '../../../authentication';
import { AdminLink, AdminHeaderLink, AdminRouterLink } from '../components/admin-area-menu-links';
import { joinURL } from '../../../utilities';
import { adminAreaPathName, jobAndOffersTabLabel, jobAndOffersTabPathName } from '../admin-area-pathnames';

import {
  offerGroupsListPathName,
  closureCausePathName,
  placementPurposePathName,
  recruitmentRequestInformationTypesPathName,
  recruitmentCollaborationPathName,
  serviceTargetTypePathName,
  forumFeedbackPathName,
} from './job-and-offers-pathnames';

export interface IJobAndOffersMenuProps {
  canSeeOfferGroups: boolean;
  canSeeForumFeedback: boolean;
}

export function JobAndOffersMenu(props: IJobAndOffersMenuProps) {
  const { canSeeOfferGroups, canSeeForumFeedback } = props;

  return (
    <>
      <Restricted
        denied=" "
        actions={[
          { resourceType: ResourceTypes.BusinessConfiguration, resourceOperation: ResourceOperations.Read },
          { resourceType: ResourceTypes.QuestionnaireFeedback, resourceOperation: ResourceOperations.Read },
        ]}
      >
        <AdminHeaderLink to={joinURL('/', adminAreaPathName, jobAndOffersTabPathName)}>{jobAndOffersTabLabel}</AdminHeaderLink>
        <Restricted denied=" " actions={[{ resourceType: ResourceTypes.BusinessConfiguration, resourceOperation: ResourceOperations.Read }]}>
          <AdminRouterLink to={joinURL('/', adminAreaPathName, jobAndOffersTabPathName, closureCausePathName)}>Lukningsårsager</AdminRouterLink>
          <AdminRouterLink to={joinURL('/', adminAreaPathName, jobAndOffersTabPathName, placementPurposePathName)}>Aktivitetsformål</AdminRouterLink>
          <AdminRouterLink to={joinURL('/', adminAreaPathName, jobAndOffersTabPathName, recruitmentRequestInformationTypesPathName)}>
            Rekrutteringsinformationstyper
          </AdminRouterLink>
          <AdminRouterLink to={joinURL('/', adminAreaPathName, jobAndOffersTabPathName, recruitmentCollaborationPathName)}>Rekrutteringssamarbejder</AdminRouterLink>
          <AdminRouterLink to={joinURL('/', adminAreaPathName, jobAndOffersTabPathName, serviceTargetTypePathName)}>Servicemåltyper</AdminRouterLink>
          {canSeeOfferGroups && <AdminLink to={joinURL('/', adminAreaPathName, jobAndOffersTabPathName, offerGroupsListPathName)}>Tilbudsgrupper</AdminLink>}
        </Restricted>
      </Restricted>

      {canSeeForumFeedback && (
        <Restricted denied=" " actions={[{ resourceType: ResourceTypes.QuestionnaireFeedback, resourceOperation: ResourceOperations.Read }]}>
          <AdminLink to={joinURL('/', adminAreaPathName, jobAndOffersTabPathName, forumFeedbackPathName)}>Forum Feedback</AdminLink>
        </Restricted>
      )}
    </>
  );
}
